import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import classnames from "classnames";
import OpenPositions from "./openPositions/OpenPositions";
import DesktopHistoryPositions from "./DesktopHistoryPositions";
import PendingOrders from "./PendingOrders";
import { useSelector } from "react-redux"; import { calculateProfitMargin, handleBulkOrderClose, handleLosingPositionsClose, handleSellOrdersClose } from "./openPositions/funtions";
import { useDispatch } from "react-redux";
import { selectOpenPositions, setTP } from "../../rtk/slices/openPositionsSlice/openPositionsSlice";
import { selectSymbols } from "../../rtk/slices/tradingSlice/tradingSlice";


// Main Component
const TradeTabs = () => {
    const [activeTab, setActiveTab] = useState("1");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [calculatedProfits, setCalculatedProfits] = useState({});
    const [totalProfit, setTotalProfit] = useState(0);
    const [totalMargin, setTotalMargin] = useState(0);

    const { positions } = useSelector(selectOpenPositions);
    const symbols = useSelector(selectSymbols);
    const dispatch = useDispatch()

    const user = JSON.parse(localStorage.getItem('user'));
    const account = user ? user.account : null;

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    // Toggle dropdown menu
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    useEffect(() => {
        Object.keys(symbols).forEach((symbol) => {
            // const { ask, bid } = symbols[symbol];
            // updatePriceProfit(symbol, ask, bid);
            calculateProfitMargin(positions, symbols, setCalculatedProfits, setTotalProfit, setTotalMargin, dispatch, setTP, totalProfit);
        });
    }, [symbols, positions]);
    return (
        <>
            <div className="d-flex bg-body justify-content-between align-items-center pe-4 border"
                style={{
                    position: 'sticky', top: "0", zIndex: 999,
                    height: "38px"
                }}
            >
                <Nav tabs className="border-0"

                >
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => toggle("1")}
                            style={{ cursor: "pointer" }}
                        >
                            Open Trades
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => toggle("2")}
                            style={{ cursor: "pointer" }}
                        >
                            Pending Orders
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "3" })}
                            onClick={() => toggle("3")}
                            style={{ cursor: "pointer" }}
                        >
                            Trade History
                        </NavLink>
                    </NavItem>

                </Nav>
                {activeTab === "1" && (
                    <>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="i" className="ri-more-2-fill" style={{ cursor: 'pointer' }} />
                            <DropdownMenu end style={{zIndex:'9999'}}>
                                <DropdownItem
                                    onClick={() => handleBulkOrderClose(positions, account, dispatch)}
                                >Close All Orders</DropdownItem>
                                <DropdownItem
                                    onClick={() => { handleLosingPositionsClose(positions, account, calculatedProfits, dispatch) }}
                                >Close Losing Orders</DropdownItem>
                                <DropdownItem
                                    onClick={() => handleSellOrdersClose(positions, account, dispatch)}
                                >Close Sell Orders</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </>
                )
                }

            </div>

            <TabContent activeTab={activeTab} className="trading-tabs-content-wrapper">
                <TabPane tabId="1">
                    <OpenPositions />
                </TabPane>
                <TabPane tabId="2">
                    <PendingOrders />
                </TabPane>
                <TabPane tabId="3">
                    <DesktopHistoryPositions />
                    {/* No Data */}
                </TabPane>
            </TabContent>
        </>
    );
};

export default TradeTabs;
